export const environment = {
  production: false,
  apiUrl: 'https://qa.truth-api.cmgservicing.com',
  msalConfig: {
    auth: {
      clientId: 'b91d473b-68de-4fd1-9485-781e5793cfa0',
      authority: 'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://865d1bd2-321f-4cc2-935d-60b7a18d6aa5/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/'
  }
};
